export default {
    data() {
        return {
            DEBUG: false,
            graphInterval: null,
            // Default number of graphs to draw
            count: 1,
            tagOptions: {},
            CHARTS: [],
        }
    },
    beforeDestroy() {
        // Tear down any event listeners
        this.destroyEventListeners();
    },
    methods: {
        /**
         * Register elements for click events (Data Tables pagination);
         */
        setupEventListeners() {
            if(this.DEBUG) console.log('setupEventListeners');
            let links = Array.from(document.querySelectorAll('ul.pagination li a.page-link'));
            links.map(link => link.addEventListener("click", event => {
                setTimeout(() => {
                    this.initializeUserTags();
                });
            }));
        },
        destroyEventListeners() {
            if(this.DEBUG) console.log('destroyEventListeners');
            let links = Array.from(document.querySelectorAll('ul.pagination li a.page-link'));
            links.map(link => link.removeEventListener("click", event => {
                setTimeout(() => {
                    this.initializeUserTags();
                });
            }));
        },
        /******************************************
         * DATA TABLES:  https://datatables.net/  *
         *****************************************/
        /**
         * initializeDataTables()
         * - Class based Data Tables
         * - Allows multiple instances per page
         * - Fina all instances of '.data-table' setup according to the data- attributes on the table element
         */
        initializeDataTables() {
            if(this.DEBUG) console.log('initializeDataTables');
            let dataTables = Array.from(document.querySelectorAll('.data-table'));
            // Loop through dataTables
            dataTables.forEach(function(dataTable) {
                // Check if table is already initialized or has no data
                if(!$.fn.dataTable.isDataTable(dataTable)) {
                    // Check if it has a 'delay-loading' class to prevent initialization until it has data
                    if($('#'+dataTable.id).hasClass('delay-loading')) {
                        return;
                    }
                    // Check data-sort attribute for custom sort order, otherwise sort by first column
                    let dtSorting = dataTable.getAttribute('data-sort') ?  JSON.parse(dataTable.getAttribute('data-sort')) : [0, "asc"];
                    // Check data-search attribute for custom search text, otherwise use default text
                    let dtSearchText = dataTable.getAttribute('data-search') ? dataTable.getAttribute('data-search') : 'Search';
                    // Check data-empty attribute for text to display when there are no records, otherwise use default text
                    let dtEmptyText = dataTable.getAttribute('data-empty') ? dataTable.getAttribute('data-empty') : 'No Records To Display';
                    // Check data-export to see what columns will be exported - defaults to visible columns
                    let dtExportColumns = dataTable.getAttribute('data-export-columns') ? JSON.parse(dataTable.getAttribute('data-export-columns')) : ':visible';
                    // Check to see if we are displaying export buttons or not
                    let showButtons = dataTable.getAttribute('data-export') ? dataTable.getAttribute('data-export') : false;
                    let dtRowGroup = dataTable.getAttribute('data-row-group') ? JSON.parse(dataTable.getAttribute('data-row-group')) : {};
                    let dtOrderFixed = dataTable.getAttribute('data-order-fixed') ? JSON.parse(dataTable.getAttribute('data-order-fixed')) : [];
                    let dtOrdering = dataTable.getAttribute('data-ordering') ? JSON.parse(dataTable.getAttribute('data-ordering')) : true;

                    let dtExportButtons = [];
                    let layout = '<"row pb-2"<"col">><"row"<"col-sm-12 col-lg-12"f>>rtip'

                    if(showButtons) {
                        // Update layout
                        layout = '<"row pb-2"<"col">><"row"<"col-sm-12 col-lg-10"f><"col-sm-12 col-lg-2 text-right-lg"<"#sau-dt-container"B>>>rtip'
                        // Populate export buttons
                        dtExportButtons = [
                            {
                                extend: 'pdfHtml5',
                                title: document.title + ' ' + moment(new Date).format('DD-MM-YYYY'),
                                exportOptions: {
                                    columns: dtExportColumns
                                }
                            },
                            {
                                extend: 'copyHtml5',
                                exportOptions: {
                                    columns: dtExportColumns
                                }
                            },
                            {
                                extend: 'excelHtml5',
                                title: document.title + ' ' + moment(new Date).format('DD-MM-YYYY'),
                                exportOptions: {
                                    columns: dtExportColumns
                                }
                            },
                            {
                                extend: 'csvHtml5',
                                title: document.title + ' ' + moment(new Date).format('DD-MM-YYYY'),
                                exportOptions: {
                                    columns: dtExportColumns
                                }
                            },
                            {
                                extend: 'print',
                                exportOptions: {
                                    columns: dtExportColumns
                                }
                            }
                        ];
                    }

                    // Initialize Data Table
                    $('#'+dataTable.id).DataTable({
                        order: dtSorting,
                        ordering: dtOrdering,
                        responsive: true,
                        pageLength: 20,
                        rowGroup: dtRowGroup,
                        orderFixed: dtOrderFixed,
                        language: {
                            search: "_INPUT_",
                            searchPlaceholder: dtSearchText,
                            zeroRecords: dtEmptyText,
                            emptyTable: dtEmptyText
                        },
                        // prevent option to sort by filtering out th with class="nosort"
                        columnDefs: [
                            {orderable: false, targets: 'nosort' },
                            {visible: false, targets: 'noshow'}
                        ],
                        dom: layout,
                        buttons: [
                            dtExportButtons
                        ],
                    });

                    // Ensure there is no current filter & redraw the table
                    $.fn.dataTableExt.afnFiltering.length = 0;
                    $('#'+dataTable.id).show();
                    $('#'+dataTable.id).DataTable().draw();

                    // Create the dropdown menu only if the selected Data Table has buttons
                    if(showButtons) {
                        // Create html for dropdown menu
                        let menuHTML = `<div class="sau-dropdown">
                                            <button class="sau-dropbtn sm">Export <i class="far fa-chevron-down"></i></button>
                                            <div class="sau-dropdown-content">
                                                <div class="sau-menu sau-dropdown-align">
                                                    <div class="sau-menu-content" id="sau-dt-buttons">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>`;

                        // Insert the html
                        let btnContainer = document.getElementById('sau-dt-container');
                        btnContainer.insertAdjacentHTML('afterbegin', menuHTML);

                        // Move buttons inside menu container
                        let dtButtons = document.querySelector('div.dt-buttons');
                        let menuContainer = document.getElementById('sau-dt-buttons');
                        menuContainer.insertAdjacentElement('afterbegin', dtButtons);

                        // Append icons to any action buttons
                        let buttons = Array.from(document.querySelectorAll('button.dt-button'));
                        buttons.forEach(button => {
                            let text = button.innerText;
                            switch(text.toLowerCase()) {
                                case 'pdf':
                                    button.innerHTML = "<span><i class='far fa-file-pdf'></i> PDF</span>";
                                        break;
                                case 'csv':
                                    button.innerHTML = "<span><i class='far fa-chart-line'></i> CSV</span>";
                                        break;
                                case 'excel':
                                    button.innerHTML = "<span><i class='far fa-file-excel'></i> Excel</span>";
                                        break;
                                case 'copy':
                                    button.innerHTML = "<span><i class='far fa-copy'></i> Copy</span>";
                                        break;
                                case 'print':
                                    button.innerHTML = "<span><i class='far fa-print'></i> Print</span>";
                                        break;
                            }
                        })
                    }
                }
            });
        },
        /*************************************************************************
         * USER TAGS:  https://goodies.pixabay.com/jquery/tag-editor/demo.html   *
         ************************************************************************/
        /**
         * initializeUserTags()
         * - Load all elements with class="load-user-tags"
         */
        initializeUserTags() {
            if(this.DEBUG) console.log('initializeUserTags');
            // Get all input tag elements
            let tagInputs = document.querySelectorAll('.load-user-tags');
            if(this.DEBUG) console.log('inputs', tagInputs);
            tagInputs.forEach((input) => {
                if(this.DEBUG) console.log('input - ', input);

                // Read Tags Off Input
                let dataTags = input.getAttribute('data-tags') ? input.getAttribute('data-tags') : [];
                let tags = dataTags.length > 0 ? dataTags.split(',') : '';

                // Destroy before initializing - prevent duplicates
                $('#'+input.id).tagEditor('destroy');

                // Assign vue instance to reference inside jquery function
                let self = this;

                // Get Elements ID
                $('#'+input.id).tagEditor({
                    initialTags: tags,
                    delimiter: ', ', // space and comma
                    placeholder: 'Enter tags ...',
                    onChange(field, editor, tags) {
                        let id = field[0].id.replace("service-",'');
                        self.saveUserTags(id, tags);
                    }
                });

            });
            this.setupEventListeners();
        },
        /*************************************************************************************
         * GRAPHS:  http://www.chartjs.org/  http://progressbarjs.readthedocs.io/en/latest/  *
         ************************************************************************************/
        /**
         * checkLazyGraphs()
        * - Check all elements with class 'lazy-...' graphs
        * - animate only when it is visible (when the user scrolls)
        */
        checkLazyGraphs() {
            if(this.DEBUG) console.log('checkLazyGraphs');
            // Check Lazy Line Graphs and Progress Bars
            // Lazy- classes are triggered on scroll when more than half the object is visible
            const lazyDoubleBars = document.querySelectorAll('canvas.lazy-double-bar-graph:not(.loading)');
            if(this.DEBUG) console.log('lazyDoubleBars', lazyDoubleBars);
            lazyDoubleBars.forEach(graph => {
                var distanceToTop = graph.getBoundingClientRect().top;
                var halfHeight = graph.getBoundingClientRect().height / 2;
                // Make sure the graphs is at least half visible before animating
                if((distanceToTop + halfHeight < window.innerHeight) && !(Math.abs(distanceToTop) < graph.height) ) {
                    // Animate Graph - need to flag so we don't continually animate it
                    this.doubleBarGraph(graph);
                    // add 'loading' class so its not reanimated on every scroll
                    graph.classList.toggle('loading');
                }
            });
            const singleLazyLines = document.querySelectorAll('canvas.lazy-single-line-graph:not(.loading');
            if(this.DEBUG) console.log('singleLazyLines', singleLazyLines);
            singleLazyLines.forEach(graph => {
                var distanceToTop = graph.getBoundingClientRect().top;
                var halfHeight = graph.getBoundingClientRect().height / 2;
                // Make sure the graphs is at least half visible before animating
                if((distanceToTop + halfHeight < window.innerHeight) && !(Math.abs(distanceToTop) < graph.height) ) {
                    // Animate Graph - need to flag so we don't continually animate it
                    this.singleLineGraph(graph);
                    // add 'loading' class so its not reanimated on every scroll
                    graph.classList.toggle('loading');
                }
            });
            const doubleLazyLines = document.querySelectorAll('canvas.lazy-double-line-graph:not(.loading');
            if(this.DEBUG) console.log('doubleLazyLines', doubleLazyLines);
            doubleLazyLines.forEach(graph => {
                var distanceToTop = graph.getBoundingClientRect().top;
                var halfHeight = graph.getBoundingClientRect().height / 2;
                // Make sure the graphs is at least half visible before animating
                if((distanceToTop + halfHeight < window.innerHeight) && !(Math.abs(distanceToTop) < graph.height) ) {
                    // Animate Graph - need to flag so we don't continually animate it
                    this.doubleLineGraph(graph);
                    // add 'loading' class so its not reanimated on every scroll
                    graph.classList.toggle('loading');
                }
            });

            // This is included as a mixin and is only responsible for 1 graph :) much easier. See if this.CHARTS has any entries and cancel the interval to draw graphs
            if(this.DEBUG) console.log('this charts', this.CHARTS);
            if(this.DEBUG) console.log('this charts length', Object.keys(this.CHARTS).length);

            if(Object.keys(this.CHARTS).length == this.count) {
                if(this.DEBUG) console.log('clearing graph interval - all graphs drawn');
                if(this.graphInterval) {
                    if(this.DEBUG) console.log('graph interval was ', this.graphInterval);
                    clearInterval(this.graphInterval);
                    this.graphInterval = null;
                    if(this.DEBUG) console.log('graph interval is ', this.graphInterval);
                }
            }

            // // Cancel Timeout if no remaining graphs need to be drawn. Array.length only works with numeric indexes so get the count by Object.keys().length
            // let graphCount = Object.keys(document.querySelectorAll('.lazy-double-bar-graph, .lazy-double-line-graph, .lazy-single-line-graph, .horizontal-double-bar-graph, .horizontal-single-bar-graph')).length;
            // let allGraphs = document.querySelectorAll('.lazy-double-bar-graph, .lazy-double-line-graph, .lazy-single-line-graph, .horizontal-double-bar-graph, .horizontal-single-bar-graph');
            // let graphsDrawn = Object.keys(this.CHARTS).length;
            // if(this.DEBUG) console.log('charts', this.CHARTS);
            // if(this.DEBUG) console.log('all graphs', allGraphs);
            // if(this.DEBUG) console.log('graphCount', graphCount);
            // if(this.DEBUG) console.log('graphsDrawn', graphsDrawn);
            // if(graphCount === graphsDrawn) {
            //     if(this.DEBUG) console.log('clearing graph interval - all graphs drawn');
            //     if(this.graphInterval) {
            //         if(this.DEBUG) console.log('graph interval was ', this.graphInterval);
            //         clearInterval(this.graphInterval);
            //         this.graphInterval = null;
            //         if(this.DEBUG) console.log('graph interval is ', this.graphInterval);
            //     }
            // }
        },

        /**
         * checkGraphs()
         * - Check all elements with 'line-graph' && 'bar-graph'
         */
        checkGraphs() {
            if(this.DEBUG) console.log('checkGraphs');
            const doubleBarGraphs = document.querySelectorAll('canvas.horizontal-double-bar-graph:not(.loading)');
            if(this.DEBUG) console.log('doublebargraphs', doubleBarGraphs);
            doubleBarGraphs.forEach(graph => {
                // Graph is waiting on data - return
                if(graph.classList.contains('loading')) return;
                this.horizontalDoubleBarGraph(graph);
            });
            const singleBarGraphs = document.querySelectorAll('canvas.horizontal-single-bar-graph:not(.loading)');
            if(this.DEBUG) console.log('singlebargraphs', singleBarGraphs);
            singleBarGraphs.forEach(graph => {
                // Graph is waiting on data - return
                if(graph.classList.contains('loading')) return;
                this.horizontalSingleBarGraph(graph);
            });
        },
        /**
         * registerAnimateOnView()
         * - used to trigger graph animations when they appear in view
         * - only register when there are graphs in the DOM
         */
        registerAnimateOnView(count) {
            this.count = count || 1;
            if(this.DEBUG) console.log('registerAnimateOnView');
            if(this.DEBUG) console.log('register ', count, ' graphs');
            var singleLineGraphs = document.querySelectorAll('.lazy-single-line-graph');
            if(this.DEBUG) console.log('singleLineGraphs', singleLineGraphs);
            var doubleLineGraphs = document.querySelectorAll('.lazy-double-line-graph');
            if(this.DEBUG) console.log('doubleLineGraphs', doubleLineGraphs);
            var doubleBarGraphs = document.querySelectorAll('.lazy-double-bar-graph');
            if(this.DEBUG) console.log('doubleBarGraphs', doubleBarGraphs);
            if(doubleBarGraphs.length || singleLineGraphs || doubleLineGraphs) {
                if(this.DEBUG) console.log('lazy graphs found');
                // Setting Interval - checkLazy Graphs
                if(this.graphInterval) {
                    if(this.DEBUG) console.log('graph interval already set', this.graphInterval);
                } else {
                    if(this.DEBUG) console.log('setting graph interval');
                    this.graphInterval = setInterval(() => {
                        this.checkLazyGraphs()
                    }, 500);
                    if(this.DEBUG) console.log('graph interval set to ', this.graphInterval);
                }
            }
        },
        /**
         * saveUserTags()
         * - Save user tags in the database
         * @param {int} serviceId
         * @param {array} userTags
         */
        saveUserTags(serviceId, userTags) {
            if(this.DEBUG) console.log('saveUserTags');
            axios.post(`/api/services/${serviceId}/tags/update`, {tags: userTags}, {
                headers: { 'Accept': 'application/json' }
            })
            .then(response => {
                if(this.DEBUG) console.log('response', response);
                // Revert tags to what was in the database if the request failed
                if(response.status == 'failed') {
                    // remove all existing tags first
                    // userTags.forEach(function(tag) {
                    //     $('#service-'+serviceId).tagEditor('removeTag', tag);
                    // })
                    // $('#service-'+serviceId).tagEditor({
                    //     initialTags: response.tags
                    // });
                }
            })
            .catch(error => {
                if(this.DEBUG) console.log('error', error);
                // remove all existing tags first
                // userTags.forEach(function(tag) {
                //     $('#service-'+serviceId).tagEditor('removeTag', tag);
                // })
                // $('#service-'+serviceId).tagEditor({
                //     initialTags: error.response.tags
                // });
            });
        },
        /**
         * doubleBarGraph()
         * - Draw bar graph using data-points attribute on canvas elements with class 'lazy-line-graph'
         * @param {node} element
         */
        doubleBarGraph(element) {
            if(this.DEBUG) console.log('Double Bar Graph');
            var data = JSON.parse(element.getAttribute('data-points'));
            var titles = Object.keys(data.points);
            var billType = element.getAttribute('data-billType');
            var stacked = true;
            if (billType==='CDR') {
                stacked = false;
            }
            if(this.CHARTS[element.id]) {
                if(this.DEBUG) console.log('Double Bar Graph exists - updating');
                // Already Exists - animate with the new value
                var doubleBarChart = this.CHARTS[element.id];
                doubleBarChart.data.datasets = [{
                    label: `${titles[0]} (${data.units})`,
                    borderColor: 'rgb(101,106,175)',
                    fill: false,
                    data: data.points[titles[0]]
                },{
                    label: `${titles[1]} (${data.units})`,
                    borderColor: 'rgb(65,120,36)',
                    fill: false,
                    data: data.points[titles[1]],
                }];
                doubleBarChart.update();
            } else {
                if(this.DEBUG) console.log('creating new Double Bar Graph');
                var doubleBarChart = new Chart(element, {
                    type: 'bar',
                    data: {
                        labels: data.labels,
                        datasets: [{
                            label: `${titles[0]} (${data.units})`,
                            borderColor: 'rgb(101,106,175)',
                            backgroundColor: 'rgba(101,106,175, 1)',
                            fill: false,
                            data: data.points[titles[0]]
                        },{
                            label: `${titles[1]} (${data.units})`,
                            borderColor: 'rgb(65,120,36)',
                            backgroundColor: 'rgba(65,120,36,0.8)',
                            fill: false,
                            data: data.points[titles[1]],
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: stacked,
                                ticks: {
                                    beginAtZero: true,
                                    // include the units after the value
                                    callback: function(value, index, values) {
                                        return value + ' ' + data.units;
                                    }
                                }
                            }],
                            xAxes: [{
                               stacked: stacked,
                            }]
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        },
                        hover: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                            onHover: function(evt, item) {
                                if(item.length) {
                                }
                            }
                        }
                    },
                });
                // Add to array
                this.CHARTS[element.id] = doubleBarChart;
                if(this.DEBUG) console.log('adding ', element, 'to charts', this.CHARTS);
            }
        },
        /**
         * SingleLineGraph()
         * - Draw bar graph using data-points attribute on canvas elements with class 'lazy-single-line-graph'
         * @param {node} element
         */
        singleLineGraph(element) {
            if(this.DEBUG) console.log('single Line Graph');
            var data = JSON.parse(element.getAttribute('data-points'));
            var titles = Object.keys(data.points);
            if(this.CHARTS[element.id]) {
                if(this.DEBUG) console.log('Single line Graph exists - updating');
                // Already Exists - animate with the new value
                var singleLineChart = this.CHARTS[element.id];
                singleLineChart.data.datasets = [{
                    label: `${titles[0]} (${data.units})`,
                    borderColor: 'rgb(101,106,175)',
                    backgroundColor: 'rgba(101,106,175, 1)',
                    fill: false,
                    data: data.points[titles[0]]
                }];
                singleLineChart.update();
            } else {
                if(this.DEBUG) console.log('creating new Single line Graph');
                var singleLineChart = new Chart(element, {
                    type: 'line',
                    data: {
                        labels: data.labels,
                        datasets: [{
                            label: `${titles[0]} (${data.units})`,
                            borderColor: 'rgb(101,106,175)',
                            backgroundColor: 'rgba(101,106,175, 1)',
                            fill: false,
                            data: data.points[titles[0]]
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    // include the units after the value
                                    callback: function(value, index, values) {
                                        return parseFloat(value).toLocaleString('en') + ' ' + data.units;
                                    }
                                }
                            }],
                            xAxes: [{
                                stacked: true,
                            }]
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        },
                        hover: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                            onHover: function(evt, item) {
                                if(item.length) {
                                }
                            }
                        }
                    },
                });
                // Add to array
                this.CHARTS[element.id] = singleLineChart;
                if(this.DEBUG) console.log('adding ', element, 'to charts', this.CHARTS);
            }
        },
        /**
         * DoubleLineGraph()
         * - Draw bar graph using data-points attribute on canvas elements with class 'lazy-single-line-graph'
         * @param {node} element
         */
        doubleLineGraph(element) {
            if(this.DEBUG) console.log('doubleLineGraph');
            var data = JSON.parse(element.getAttribute('data-points'));
            var titles = Object.keys(data.points);
            if(this.CHARTS[element.id]) {
                if(this.DEBUG) console.log('doubleLineGraph exists - updating');
                // Already Exists - animate with the new value
                var doubleLineChart = this.CHARTS[element.id];
                doubleLineChart.data.datasets = [{
                    label: `${titles[0]} (${data.units})`,
                    borderColor: 'rgb(101,106,175)',
                    backgroundColor: 'rgba(101,106,175, 1)',
                    fill: false,
                    data: data.points[titles[0]]
                },{
                    label: `${titles[1]} (${data.units})`,
                    borderColor: 'rgb(65,120,36)',
                    backgroundColor: 'rgba(65,120,36,1)',
                    fill: false,
                    data: data.points[titles[1]]
                }];
                doubleLineChart.update();
            } else {
                if(this.DEBUG) console.log('creating new doubleLineGraph');
                var doubleLineChart = new Chart(element, {
                    type: 'line',
                    data: {
                        labels: data.labels,
                        datasets: [{
                            label: `${titles[0]} (${data.units})`,
                            borderColor: 'rgb(101,106,175)',
                            backgroundColor: 'rgba(101,106,175, 1)',
                            fill: false,
                            data: data.points[titles[0]]
                        },{
                            label: `${titles[1]} (${data.units})`,
                            borderColor: 'rgb(65,120,36)',
                            backgroundColor: 'rgba(65,120,36,1)',
                            fill: false,
                            data: data.points[titles[1]]
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    // include the units after the value
                                    callback: function(value, index, values) {
                                        return parseFloat(value).toLocaleString('en') + ' ' + data.units;
                                    }
                                }
                            }],
                            xAxes: [{
                                stacked: true,
                            }]
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        },
                        hover: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                            onHover: function(evt, item) {
                                if(item.length) {
                                }
                            }
                        }
                    },
                });
                // Add to array
                this.CHARTS[element.id] = doubleLineChart;
                if(this.DEBUG) console.log('adding ', element, 'to charts', this.CHARTS);
            }
        },
        /**
         * horizontalDoubleBarGraph()
         * - renders a horizontal bar graph
         * @param {node} element
         */
        horizontalDoubleBarGraph(element) {
            if(this.DEBUG) console.log('horizontalDoubleBarGraph');
            var data = JSON.parse(element.getAttribute('data-points'));
            if(this.CHARTS[element.id]) {
                if(this.DEBUG) console.log('horizontalDoubleBarGraph exists - updating');
                // Already Exists - animate with the new value
                var horizontalDoubleBarChart = this.CHARTS[element.id];
                horizontalDoubleBarChart.data.labels = [`${data.usage}%`];
                horizontalDoubleBarChart.data.datasets = [{
                    label: `In`,
                    borderColor: 'rgb(101,106,175)',
                    backgroundColor: 'rgba(101,106,175,1)',
                    fill: false,
                    data: [data.percentIn]
                },{
                    label: `Out`,
                    borderColor: 'rgb(65,120,36)',
                    backgroundColor: 'rgba(65,120,36,1)',
                    fill: false,
                    data: [data.percentOut],
                }];
                horizontalDoubleBarChart.options.scales.xAxes = [{
                    stacked: true,
                    ticks: {
                        beginAtZero: true,
                        max: data.usage < 100 ? 100 : parseInt(data.usage),
                    },
                }];
                horizontalDoubleBarChart.update();
            } else {
                if(this.DEBUG) console.log('creating new horizontalDoubleBarGraph');
                var horizontalDoubleBarChart = new Chart(element, {
                    type: 'horizontalBar',
                    data: {
                        labels: [`${data.usage}%`],
                        datasets: [{
                            label: `In`,
                            borderColor: 'rgb(101,106,175)',
                            backgroundColor: 'rgba(101,106,175,1)',
                            fill: false,
                            data: [data.percentIn]
                        },{
                            label: `Out`,
                            borderColor: 'rgb(65,120,36)',
                            backgroundColor: 'rgba(65,120,36,1)',
                            fill: false,
                            data: [data.percentOut],
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                categoryPercentage: 1,
                                barPercentage: 1,
                            }],
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    max: data.usage < 100 ? 100 : parseInt(data.usage),
                                },
                            }]
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            position: 'nearest',
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        },
                        hover: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        }
                    },
                });
                // Add to array
                this.CHARTS[element.id] = horizontalDoubleBarChart;
                if(this.DEBUG) console.log('adding ', element, 'to charts', this.CHARTS);
            }
        },
        /**
         * horizontalBarGraph()
         * - renders a horizontal bar graph
         * @param {node} element
         */
        horizontalSingleBarGraph(element) {
            if(this.DEBUG) console.log('horizontalSingleBarGraph');
            var data = JSON.parse(element.getAttribute('data-points'));
            if(this.CHARTS[element.id]) {
                if(this.DEBUG) console.log('horizontalSingleBarGraph exists - updating');
                // Already Exists - animate with the new value
                var horizontalSingleBarChart = this.CHARTS[element.id];
                horizontalSingleBarChart.data.labels = [`${data.percent}`];
                horizontalSingleBarChart.data.datasets = [{
                    label: `Percent`,
                    borderColor: 'rgb(101,106,175)',
                    backgroundColor: 'rgba(101,106,175,1)',
                    fill: false,
                    data: [data.percent.replace('%','')]
                }];
                horizontalSingleBarChart.update();
            } else {
                if(this.DEBUG) console.log('creating new horizontalSingleBarGraph');
                var horizontalSingleBarChart = new Chart(element, {
                    type: 'horizontalBar',
                    data: {
                        labels: [`${data.percent}`],
                        datasets: [{
                            label: `Percent`,
                            borderColor: 'rgb(101,106,175)',
                            backgroundColor: 'rgba(101,106,175,1)',
                            fill: false,
                            data: [data.percent.replace('%','')]
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                categoryPercentage: 1,
                                barPercentage: 1,
                            }],
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    max: 100,
                                },
                            }]
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        },
                        hover: {
                            mode: 'index',
                            intersect: true,
                            backgroundColor: 'rgba(0,0,0, 0.8)',
                        }
                    },
                });
                // Add to array
                this.CHARTS[element.id] = horizontalSingleBarChart;
                if(this.DEBUG) console.log('adding ', element, 'to charts', this.CHARTS);
            }
        },
        registerToolTips() {
            if(this.DEBUG) console.log('registerToolTips');
            /** timeout to ensure the dom has loaded correctly */
            setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip()
            }, 1500);
        }
    }
}
